export enum TransactionAmountType {
  FINAL = 'FINAL',
  ESTIMATED = 'ESTIMATED',
  NOT_CURRENTLY_KNOWN = 'NOT_CURRENTLY_KNOWN',
}

export type EncryptedWalletRequest = {
  name: string;
  transactionAmountType: TransactionAmountType;
  applePayPaymentData: unknown;
  address_line1?: string;
  address_zip?: string;
};

export type TokenRequest = {
  encryptedWallet: EncryptedWalletRequest;
};

export type TokenResponse = {
  id: string;
  token: string;
  object?: string;
  wallet?: {
    exp_month: string;
    exp_year: string;
    last4: string;
    first6: string;
    brand: string;
    address_line1: string;
    address_zip: string;
  };
};
